// OGC Email Verification page interactions
(function () {
  function init() {
    var root = document.querySelector('[data-ogc-email-verification-page]');
    if (!root) return;

    // Keep prototype selectors contained to this Shopify section.
    var documentQuerySelector = document.querySelector.bind(document);
    var documentQuerySelectorAll = document.querySelectorAll.bind(document);
/* ── Scroll reveal ── */
  (function () {
    var els = root.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach(function(el){ el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* ── Verifier animation ──
     Self-playing loop: types the address, runs a "verifying" beat, then
     reveals the Deliverable result, staggers the checks and counts the score.
     Purely decorative — the card is aria-hidden and the same information is
     covered in the sections below. */
  (function () {
    var app = document.getElementById('verifyApp');
    if (!app) return;
    var inputEl = document.getElementById('vaInput');
    var textEl  = document.getElementById('vaText');
    var caretEl = document.getElementById('vaCaret');
    var btnEl   = document.getElementById('vaBtn');
    var resEl   = document.getElementById('vaResult');
    var ringEl  = document.getElementById('vaRing');
    var scoreEl = document.getElementById('vaScore');
    var items   = [].slice.call(app.querySelectorAll('.check-item'));

    var EMAIL = 'wilson@horizontech.com';
    var SCORE = 98;
    var C = 150.8;                 // circumference for r=24
    var RING_END = C * (1 - SCORE / 100);
    var timers = [];
    function at(ms, fn) { timers.push(setTimeout(fn, ms)); }
    function clearAll() { timers.forEach(clearTimeout); timers = []; }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function showFinal() {
      textEl.textContent = EMAIL;
      caretEl.classList.add('is-off');
      inputEl.classList.remove('is-active');
      btnEl.classList.remove('is-loading');
      resEl.classList.add('is-shown');
      items.forEach(function (i) { i.classList.add('is-in'); });
      ringEl.setAttribute('stroke-dashoffset', RING_END.toFixed(1));
      scoreEl.textContent = SCORE;
    }

    function reset() {
      textEl.textContent = '';
      caretEl.classList.remove('is-off');
      inputEl.classList.remove('is-active');
      btnEl.classList.remove('is-loading');
      resEl.classList.remove('is-shown');
      items.forEach(function (i) { i.classList.remove('is-in'); });
      ringEl.setAttribute('stroke-dashoffset', C.toFixed(1));
      scoreEl.textContent = '0';
    }

    function countScore(dur) {
      var start = null, done = false;
      function step(ts) {
        if (done) return;
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        scoreEl.textContent = Math.round(p * SCORE);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      // rAF is throttled in background/occluded tabs, which would leave the
      // number stuck at 0 while the ring reads 98 — so land it either way.
      at(dur + 60, function () { done = true; scoreEl.textContent = SCORE; });
    }

    function play() {
      clearAll();
      reset();

      var t = 500;
      at(t, function () { inputEl.classList.add('is-active'); });

      // Type the address
      var SPEED = 55;
      for (var i = 0; i < EMAIL.length; i++) {
        (function (n) {
          at(t + 250 + n * SPEED, function () { textEl.textContent = EMAIL.slice(0, n + 1); });
        })(i);
      }
      t += 250 + EMAIL.length * SPEED;

      // Verifying beat
      at(t + 350, function () { caretEl.classList.add('is-off'); btnEl.classList.add('is-loading'); });

      // Reveal result
      var reveal = t + 350 + 1100;
      at(reveal, function () {
        btnEl.classList.remove('is-loading');
        inputEl.classList.remove('is-active');
        resEl.classList.add('is-shown');
        ringEl.setAttribute('stroke-dashoffset', RING_END.toFixed(1));
        countScore(800);
      });
      items.forEach(function (item, n) {
        at(reveal + 180 + n * 110, function () { item.classList.add('is-in'); });
      });

      // Hold, then loop
      at(reveal + 180 + items.length * 110 + 4200, play);
    }

    if (reduce) { showFinal(); return; }

    // Only run while the card is on screen
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { play(); } else { clearAll(); reset(); }
        });
      }, { threshold: 0.25 });
      io.observe(app);
    } else {
      play();
    }
  })();

    if (window.lucide) window.lucide.createIcons();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
